import moment from 'moment'
export function isOlder(value) {
  const dates = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD');
  const newdate = new Date(dates);
  const diference = (new Date().getTime() - newdate.getTime() ) / 31536000000;
  return diference > 18.0
}